export default __webpack_public_path__ + "static/media/stat-total-deals.92f89212.svg";